import _ from 'lodash'

import {
    ANNOTATIONS_TABLE_CHANGE,
    ANNOTATIONS_TABLE_CHANGE_REQUEST,
    ANNOTATIONS_TABLE_LOADING_TRUE,
    ANNOTATIONS_TABLE_DATA_RECEIVED,
    ANNOTATIONS_TABLE_LOADING_FALSE,
} from './constants'

import config from '../../../../../../../../../config'

export function annotationsTableChange(module, blockKey, id, level, customData, queryParams) {
    return {
        type: ANNOTATIONS_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            customData,
            queryParams,
        },
    }
}

export function annotationsTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: ANNOTATIONS_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.${module}.${blockKey}.block[1].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function annotationsTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: ANNOTATIONS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function annotationsTableDataReceived(module, id, blockKey, customData) {
    return {
        type: ANNOTATIONS_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function annotationsTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: ANNOTATIONS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
